import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomExportAiMappingRunAreaPdfMutation } from "generated/graphql";

export const useExportAiMappingRunAreaPdf = () => {
  const [mutation, { data, loading, error }] = useCustomExportAiMappingRunAreaPdfMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "exportAiMappingRunAreaPdf" },
    { hideMessage: true }
  );
};
